
    (window.__NEXT_P=window.__NEXT_P||[]).push(["/", function() {
      var mod = require("/Users/catalina/Code/html/nost-plugins/src/pages/index.jsx")
      if(module.hot) {
        module.hot.accept("/Users/catalina/Code/html/nost-plugins/src/pages/index.jsx", function() {
          if(!next.router.components["/"]) return
          var updatedPage = require("/Users/catalina/Code/html/nost-plugins/src/pages/index.jsx")
          next.router.update("/", updatedPage)
        })
      }
      return mod
    }]);
  